require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-content-writing-social-media-bios.json") })
        }
      }, "path---services-content-writing-social-media-bios");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-content-writing-social-media-bios!./.cache/json/services-content-writing-social-media-bios.json
// module id = 737
// module chunks = 231608221292675